import { useMemo } from 'react';

import { createArtifactScanNotesLookup } from '@kaiizen/kai-pro-api';

import { useScanEditingContextSlice } from './ScanEditingContext';
import { useScanNotes } from './useScanNotes';

/**
 * The notes each scan part shows on an artifact, built the same way as the server's artifacts.
 *
 * Reads the notes of `scanId`, defaulting to the editing context's scan. A report built for another
 * scan, such as a change order's baseline, passes that scan's id, so it gets that scan's notes and
 * the ones carried over to it rather than the current scan's: a note added on the change order
 * never prints on the approved scope it was copied from.
 */
export const useArtifactScanNotesLookup = (scanId?: string) => {
  const { scanId: contextScanId, scanNotes: contextScanNotes } = useScanEditingContextSlice(['scanId', 'scanNotes']);
  const otherScanId = scanId && scanId !== contextScanId ? scanId : undefined;
  // Disabled (no fetch) while `otherScanId` is undefined.
  const { data: otherScanNotes } = useScanNotes(otherScanId);
  const scanNotes = otherScanId ? otherScanNotes : contextScanNotes;
  return useMemo(() => createArtifactScanNotesLookup(scanNotes ?? []), [scanNotes]);
};
